module.exports = __webpack_public_path__ + "static/media/image-video-11.d9e24380.png";